import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import classNames from 'classnames';
import noop from 'lodash/noop';
import Select from '../selects/Select';
import ToggleButton from '../button/ToggleButton';
const TableCardsSorting = (props) => {
    const { sortName: controlledSortName, sortOrder: controlledSortOrder = 'asc', selectOptions, onSortChange = noop, className, } = props;
    const [sortName, setSortName] = useState(controlledSortName);
    const [sortOrder, setSortOrder] = useState(controlledSortOrder);
    const updateSortOrder = (newSortOrder) => {
        setSortOrder(newSortOrder);
        onSortChange(sortName, newSortOrder);
    };
    const updateSortName = (newSortName) => {
        setSortName(newSortName);
        onSortChange(newSortName, sortOrder);
    };
    const wrapperClassNames = classNames('table-toolbar-cards-sorting', 'btn-toolbar', className && className);
    return (_jsxs("div", Object.assign({ className: wrapperClassNames }, { children: [_jsxs("div", Object.assign({ className: 'btn-group margin-left-0' }, { children: [_jsx(ToggleButton, Object.assign({ className: 'btn-icon-only', active: sortOrder === 'asc', onClick: () => updateSortOrder('asc') }, { children: _jsx("span", { className: 'rioglyph rioglyph-sort-by-attributes-alt' }) })), _jsx(ToggleButton, Object.assign({ className: 'btn-icon-only', active: sortOrder === 'desc', onClick: () => updateSortOrder('desc') }, { children: _jsx("span", { className: 'rioglyph rioglyph-sort-by-attributes' }) }))] })), selectOptions.length && (_jsx("div", Object.assign({ className: 'btn-group' }, { children: _jsx(Select, { options: selectOptions, onChange: item => item && updateSortName(item.id) }) })))] })));
};
export default TableCardsSorting;
